import React from 'react'
import { FieldComponent } from 'components/Shared/FieldComponent'
import withStyles from '@material-ui/core/styles/withStyles'

export function IndependentFieldComponent ({ fieldName }) {
  return (<StyledFieldComponent fieldName={fieldName}/>)
}

const StyledFieldComponent = withStyles(() => ({
  root: {
    '& div input.MuiInputBase-input': {
      paddingTop: '12px'
    },
    '& div.MuiInputBase-root': {
      height: '50px'
    }
  }
}))(FieldComponent)
